export default {"src":"/_next/static/media/2.023f6d94.svg","height":105,"width":98,"blurWidth":0,"blurHeight":0};